import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { installSessionExpiredKickoff } from './auth/loginKickoff';
import './i18n/i18n';
// Registers the self-hosted @font-face rules (Roboto + Roboto Mono) app-wide.
import './theme/fonts';

// A silent refresh that fails anywhere in the app restarts centralized login. Registered
// here (rather than imported by the HTTP client) so the client never depends on the
// navigation layer.
installSessionExpiredKickoff();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');
createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
